<template>
  <div class="tile is-child">
    <div class="panel">
      <p class="panel-heading">
        Points Calculator
      </p>
      <div class="panel-block">
        <p class="control">
          <label class="label"><small>Place</small></label>
          <select>
            <option
              v-for="item in places"
              @click="selectPlace(item)"
            >
              {{ item.place }}
            </option>
          </select>
        </p>
        <p class="control">
          <label class="label"><small>Players</small></label>
          <input
            v-model="numberOfPlayers"
            class="input is-small"
            type="text"
          >
        </p>
      </div>
      <div class="panel-block">
        <p>Points awarded: {{ calculatePoints(currentPlace.base, currentPlace.multiple) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SidebarPointCalculator',
    data () {
      return {
        numberOfPlayers: 45,
        places: [
          {
            place: '1st',
            base: 560,
            multiple: 1
          },
          {
            place: '2nd',
            base: 360,
            multiple: 1
          },
          {
            place: '3rd',
            base: 250,
            multiple: 1
          },
          {
            place: '4th',
            base: 210,
            multiple: 1
          },
          {
            place: '5th',
            base: 180,
            multiple: 1
          },
          {
            place: '6th',
            base: 160,
            multiple: 1
          },
          {
            place: '7th',
            base: 140,
            multiple: 1
          },
          {
            place: '8th',
            base: 100,
            multiple: 1
          },
          {
            place: '9th',
            base: 30,
            multiple: 1
          },
          {
            place: '10th',
            base: 30,
            multiple: 0.9
          },
          {
            place: '11th',
            base: 30,
            multiple: 0.8
          },
          {
            place: '12th',
            base: 30,
            multiple: 0.7
          },
          {
            place: '13th',
            base: 30,
            multiple: 0.6
          },
          {
            place: '14th',
            base: 30,
            multiple: 0.5
          },
          {
            place: '15th',
            base: 30,
            multiple: 0.4
          },
          {
            place: '16th',
            base: 30,
            multiple: 0.3
          }
        ],
        currentPlace: {}
      }
    },
    computed: {
      inputValidation () {
        let players = +this.numberOfPlayers
        if (this.numberOfPlayers <= 0 || isNaN(this.numberOfPlayers)) {
          return 64
        } else {
          return players.toFixed(0)
        }
      }
    },
    mounted () {
      this.currentPlace = this.places[0]
    },
    methods: {
      calculatePoints (base, multiple) {
        return (+base + (+multiple * this.inputValidation)).toFixed(0)
      },
      selectPlace (place) {
        this.currentPlace = place
      }
    }
  }
</script>